import { render, staticRenderFns } from "./AlarmDetailsControl.vue?vue&type=template&id=271f1595&scoped=true&"
import script from "./AlarmDetailsControl.vue?vue&type=script&lang=ts&"
export * from "./AlarmDetailsControl.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmDetailsControl.vue?vue&type=style&index=0&id=271f1595&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f1595",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VSpacer,VTooltip})
